import { AppEntity } from '@app/icare/db/schema/common/app'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { msg } from '@lingui/core/macro'
import { defineEnum } from '@pkg/shared/utils/enum-builder'
import dayjs from 'dayjs'
import { z } from 'zod'

export const PatientRelation = AppEntity.extend({
  id: z.string(),
  patientId: PatientId.ref.nullish(),
  activeFrom: z.iso.date().nullish(),
  activeTo: z.iso.date().nullish(),
})

export interface SimpleRelationValidPeriod {
  /**
   * The date from which the relation is valid
   */
  activeFrom?: Date | null | string

  /**
   * The date until which the relation is valid
   */
  activeTo?: Date | null | string
}

export type PatientRelationType = z.infer<typeof PatientRelation>

export const PatientEntityRelation = PatientRelation.extend({
  to: AppEntity,
})

export type PatientEntityRelationType = z.infer<typeof PatientEntityRelation>

export function isPatientRelation(val: unknown): val is PatientRelationType {
  return typeof val === 'object' && val !== null && 'activeFrom' in val && 'activeTo' in val
}

export function isPatientEntityRelation(val: unknown): val is PatientEntityRelationType {
  return (val as PatientEntityRelationType)?.to !== undefined && (val as PatientEntityRelationType)?.to !== null
}

export const RelationStatusEnum = defineEnum({
  active: msg`Aktiv`,
  inactive: msg`Inaktiv`,
  future: msg`Zukünftig`,
})

export type RelationStatusType = typeof RelationStatusEnum.$.Type

export const getRelationStatus = (relation?: SimpleRelationValidPeriod | null) => {
  const isInFuture = relation?.activeFrom ? dayjs(relation.activeFrom).isAfter(dayjs()) : false
  const isEnded = relation?.activeTo ? dayjs(relation.activeTo).isBefore(dayjs()) : false
  if (isEnded) {
    return RelationStatusEnum.inactive
  }
  if (isInFuture) {
    return RelationStatusEnum.future
  }
  return RelationStatusEnum.active
}
